<template lang="pug">
  div
    v-dropdown(
      ref="dropdown"
      width-auto
      position-right)
      v-btn(icon)
        v-icon(
          font-size="1.2"
          icon="cog")
      div(
        slot="content"
        style="width: 20rem;")
        v-card(elevated)
          v-card-content
            v-btn.mb-4.mt-1(
              small
              ghost
              @click="onEdit")
              v-icon(
                position-left
                font-size="1"
                icon="pencil-alt")
              span {{ $t('base.edit') }}
            v-btn.mb-4(
              ghost
              small
              @click="onPasswordChange")
              v-icon(
                position-left
                font-size="1"
                icon="key")
              span {{ 'auth.changes_password' | translate }}
            delete-btn(
              @delete="onDelete")
              v-btn(
                small
                danger
                ghost)
                v-icon(
                  position-left
                  font-size="1"
                  :icon="['far', 'trash-alt']")
                span {{ 'base.delete' | translate }}
</template>

<script>
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'EditDropdown',

  components: {
    DeleteBtn
  },

  methods: {
    onEdit () {
      this.$refs.dropdown.closeDropdown()
      this.$emit('edit')
    },

    onPasswordChange () {
      this.$refs.dropdown.closeDropdown()
      this.$emit('change-password')
    },

    onDelete () {
      this.$refs.dropdown.closeDropdown()
      this.$emit('delete')
    }
  }
}
</script>
